import { FlowNodeBase } from './FlowNodeBase';
import { FlowNodeResourceChips } from './FlowNodeResourceChips';

interface FlowAgentNodeData {
  label: string;
  status: string;
  config: {
    personaId?: string;
    agentType?: string;
    model?: string;
    providerSecretId?: string;
  };
}

export function FlowAgentNode({ data, selected }: { data: FlowAgentNodeData; selected?: boolean }) {
  return (
    <FlowNodeBase
      nodeType="agent"
      label={data.label}
      selected={selected}
      isActive={data.status === 'running'}
      status={data.status}
    >
      <FlowNodeResourceChips
        personaId={data.config.personaId}
        agentType={data.config.agentType}
        model={data.config.model}
        providerSecretId={data.config.providerSecretId}
        slots={{ agentType: true, model: true, providerKey: true }}
      />
    </FlowNodeBase>
  );
}
